import { Button } from "@/components";
import { FONT } from "@/styles/common";
import { Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomWrapper = styled(Flex)`
    position: relative;
    width: 100%;
    gap: 24px;
    box-sizing: border-box;
    ${FONT("pretendard", 16, 500)};
`;

export const CustomButton = styled(Button)`
    position: absolute;
    right: 0;
    top: 16px;
    width: 96px;
    height: 32px;
    border: 1px solid ${({ theme }) => theme.COLOR.gray[300]};
    ${FONT("pretendard", 16, 500, 1)};
    border-radius: 38px;

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        top: auto;
        bottom: 180px;
    }
`;
